import ApolloClient from 'apollo-boost';
import { GET_LOGIN_ADMIN, GET_MESSAGE_COUNT } from '../constants/login';

const client = new ApolloClient({
    uri: '/graphql',
    request: operation => {
        const token = localStorage.getItem('apollo-token');
        operation.setContext({
            headers: {
                authorization: token ? `Bearer ${token}` : ''
            }
        });
    }
});

const vuexModules = {
    namespaced: true,
    state: {
        loginAdmin: ''
    },
    mutations: {
        setLoginAdmin (state, loginAdmin) {
            state.loginAdmin = loginAdmin;
        },
        setMessageCount (state, messageCount) {
            state.messageCount = messageCount;
        }
    },
    actions: {
        async getLoginAdmin ({ commit }) {
            await client
                .query({ query: GET_LOGIN_ADMIN, fetchPolicy: 'no-cache' })
                .then(res => {
                    commit('setLoginAdmin', res.data.getLoginAdmin);
                })
                .catch(error => {
                    commit('setLoginAdmin', '');
                    this.error = error;
                });
        },
        async getMessageCount ({ commit }) {
            await client
                .query({
                    query: GET_MESSAGE_COUNT,
                    fetchPolicy: 'no-cache',
                    variables: {
                        golf_group_code: process.env.VUE_APP_GROUP_CODE
                    }
                })
                .then(res => {
                    commit('setMessageCount', res.data.getMessageCount.count);
                })
                .catch(error => {
                    commit('setMessageCount', 0);
                    this.error = error;
                });
        }
    }
};

export default vuexModules;
